import { getFilter, getProcessSearchInput } from 'gcs-common/slices/processes/processesSelectors';
import { resetProcessFilter, searchInputUpdated } from 'gcs-common/slices/processes/processesSlice';
import { useDispatch, useSelector } from 'react-redux';
import SearchBar from '../../SearchBar/SearchBar';

const ProcessSearch = () => {
  const dispatch = useDispatch();
  const filter = useSelector(getFilter);
  const searchInput = useSelector(getProcessSearchInput);

  const onSearchInputChange = ($event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = $event.target;
    dispatch(searchInputUpdated({ searchInput: value }));
  };

  const resetFilter = () => dispatch(resetProcessFilter());

  return (
    <SearchBar
      searchInput={searchInput}
      filter={filter}
      onSearchInputChange={onSearchInputChange}
      resetFilter={resetFilter}
      placeholder="Vorgangsnummer, Erfassungsdatum, Auftragsnummer oder -text"
    />
  );
};

export default ProcessSearch;
